import { render, staticRenderFns } from "./StatisPreSession.vue?vue&type=template&id=601bf370&scoped=true&"
import script from "./StatisPreSession.vue?vue&type=script&lang=js&"
export * from "./StatisPreSession.vue?vue&type=script&lang=js&"
import style0 from "./StatisPreSession.vue?vue&type=style&index=0&id=601bf370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601bf370",
  null
  
)

export default component.exports